import { getQuestionLinkOptions } from 'App/services/AssessmentQuestionService';
import { useQuery } from 'react-query';

function useFetchQuestionLinkOptions() {
    return useQuery(['assessment', 'linkOptions'], getQuestionLinkOptions, {
        retry: false,
        refetchInterval: false,
        refetchOnWindowFocus: false,
    });
}

export default useFetchQuestionLinkOptions;
